export const initHubspotHelp = () => {
    let t = document.createElement('script');
    t.type = 'text/javascript';
    t.id = 'hs-script-loader';
    t.async = !0;
    t.defer = !0;
    t.src = '//js-na1.hs-scripts.com/6542425.js';
    let n = document.getElementsByTagName('script')[0];
    n.parentNode.insertBefore(t, n);
};
